import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_b1094982 from 'nuxt_plugin_plugin_b1094982' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_pluginutils_f76033f4 from 'nuxt_plugin_pluginutils_f76033f4' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_65ef09d1 from 'nuxt_plugin_pluginrouting_65ef09d1' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_8ef4c984 from 'nuxt_plugin_pluginmain_8ef4c984' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_apollomodule_08c758be from 'nuxt_plugin_apollomodule_08c758be' // Source: ./apollo-module.js (mode: 'all')
import nuxt_plugin_axios_3755a656 from 'nuxt_plugin_axios_3755a656' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_vuelazyload_d07c1d40 from 'nuxt_plugin_vuelazyload_d07c1d40' // Source: ../src/plugins/vue-lazyload.js (mode: 'client')
import nuxt_plugin_timeago_5e62855e from 'nuxt_plugin_timeago_5e62855e' // Source: ../src/plugins/timeago.js (mode: 'all')
import nuxt_plugin_consentRevoke_6d42222d from 'nuxt_plugin_consentRevoke_6d42222d' // Source: ../src/plugins/consentRevoke.js (mode: 'client')
import nuxt_plugin_analytics_2e48c327 from 'nuxt_plugin_analytics_2e48c327' // Source: ../src/plugins/analytics.js (mode: 'client')
import nuxt_plugin_cookies_2c3cf8fe from 'nuxt_plugin_cookies_2c3cf8fe' // Source: ../src/plugins/cookies.js (mode: 'client')
import nuxt_plugin_highcharts_7c46c66a from 'nuxt_plugin_highcharts_7c46c66a' // Source: ../src/plugins/highcharts.js (mode: 'client')
import nuxt_plugin_apolloOverrides_72f66a56 from 'nuxt_plugin_apolloOverrides_72f66a56' // Source: ../src/plugins/apolloOverrides.js (mode: 'all')
import nuxt_plugin_auth_d109e48a from 'nuxt_plugin_auth_d109e48a' // Source: ./auth.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Beams: Artificial Intelligence to Empower Analysts","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, viewport-fit=cover"},{"hid":"description","name":"description","content":"Beams is a cutting-edge insights and artificial intelligence company empowering researchers and analysts with software-based capabilities."},{"hid":"application-name","name":"application-name","content":"Beams: Artificial Intelligence to Empower Analysts"},{"name":"msapplication-TileColor","content":"#da532c"},{"name":"theme-color","content":"#000000"},{"hid":"og:title","property":"og:title","content":"Beams: Artificial Intelligence to Empower Analysts"},{"hid":"og:description","property":"og:description","content":"Beams is a cutting-edge insights and artificial intelligence company empowering researchers and analysts with software-based capabilities."},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fbeams.fm\u002Fshare\u002Fdefault.png"},{"hid":"og:image:width","property":"og:image:width","content":"720"},{"hid":"og:image:height","property":"og:image:height","content":"378"},{"hid":"fb:app_id","property":"fb:app_id","content":"869345446756700"},{"hid":"og:type","property":"og:type","content":"article"},{"hid":"twitter:card","property":"twitter:card","content":"summary_large_image"},{"hid":"twitter:site","property":"twitter:site","content":"@beamsfm"},{"hid":"twitter:title","property":"twitter:title","content":"Beams: Artificial Intelligence to Empower Analysts"},{"hid":"twitter:description","property":"twitter:description","content":"Beams is a cutting-edge insights and artificial intelligence company empowering researchers and analysts with software-based capabilities."},{"hid":"twitter:image","property":"twitter:image","content":"https:\u002F\u002Fbeams.fm\u002Fshare\u002Fdefault.png"}],"link":[{"hid":"favicon-apple-touch","rel":"apple-touch-icon","sizes":"180x180","href":"\u002Ffavicon\u002Fapple-touch-icon.png"},{"hid":"favicon-icon-32","rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicon\u002Ffavicon-32x32.png"},{"hid":"favicon-icon-16","rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicon\u002Ffavicon-16x16.png"},{"rel":"manifest","href":"\u002Ffavicon\u002Fsite.webmanifest"},{"rel":"mask-icon","href":"\u002Ffavicon\u002Fsafari-pinned-tab.svg","color":"#5bbad5"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_b1094982 === 'function') {
    await nuxt_plugin_plugin_b1094982(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_f76033f4 === 'function') {
    await nuxt_plugin_pluginutils_f76033f4(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_65ef09d1 === 'function') {
    await nuxt_plugin_pluginrouting_65ef09d1(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_8ef4c984 === 'function') {
    await nuxt_plugin_pluginmain_8ef4c984(app.context, inject)
  }

  if (typeof nuxt_plugin_apollomodule_08c758be === 'function') {
    await nuxt_plugin_apollomodule_08c758be(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3755a656 === 'function') {
    await nuxt_plugin_axios_3755a656(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuelazyload_d07c1d40 === 'function') {
    await nuxt_plugin_vuelazyload_d07c1d40(app.context, inject)
  }

  if (typeof nuxt_plugin_timeago_5e62855e === 'function') {
    await nuxt_plugin_timeago_5e62855e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_consentRevoke_6d42222d === 'function') {
    await nuxt_plugin_consentRevoke_6d42222d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_analytics_2e48c327 === 'function') {
    await nuxt_plugin_analytics_2e48c327(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_cookies_2c3cf8fe === 'function') {
    await nuxt_plugin_cookies_2c3cf8fe(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_highcharts_7c46c66a === 'function') {
    await nuxt_plugin_highcharts_7c46c66a(app.context, inject)
  }

  if (typeof nuxt_plugin_apolloOverrides_72f66a56 === 'function') {
    await nuxt_plugin_apolloOverrides_72f66a56(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_d109e48a === 'function') {
    await nuxt_plugin_auth_d109e48a(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
